import { useTranslation } from 'react-i18next';
import channelsOptions from 'basics/options/channel.options';
import sotrFilterOptions from 'basics/options/sotrFilter.options';
import useCepTemplateSelectorFiltersSchema from 'components/CepTemplateSelectorFilters/CepTemplateSelectorFilters.schema';
import { CepTemplateSelectorFiltersConfigType } from 'components/CepTemplateSelectorFilters/CepTemplateSelectorFilters.types';
import { SortFilter } from 'generated/maya.types';

const useCepTemplateSelectorFiltersConfig = () => {
  const { t } = useTranslation();

  const cepTemplateSelectorFiltersSchema = useCepTemplateSelectorFiltersSchema();

  const cepTemplateSelectorFiltersConfig: CepTemplateSelectorFiltersConfigType = {
    channel: {
      name: 'channel',
      placeholder: t('maya_cep_template_selector_filters_channel_placeholder'),
      options: channelsOptions(),
      defaultValue: [],
      required: false,
      validation: cepTemplateSelectorFiltersSchema.channel,
      disableRenderTags: true,
    },
  };

  const cepSortFieldConfig = {
    name: 'sort',
    placeholder: t('sort_placeholder'),
    options: sotrFilterOptions,
    defaultValue: SortFilter.MOST_POPULAR,
    required: false,
  };

  return {
    cepTemplateSelectorFiltersConfig,
    cepSortFieldConfig,
  };
};

export default useCepTemplateSelectorFiltersConfig;
